export default __webpack_public_path__ + "static/media/token_main.1420317c.png";